<div
  class="banner"
  role="banner"
  [ngClass]="{
    'show-btn': showBtn,
    'is-home': isHomePage,
  }"
>
  @if (isHomePage) {
    <ng-container *ngTemplateOutlet="withLogo"></ng-container>
  } @else {
    <ng-container *inPopulation="[populations.Default]">
      <ng-container *ngTemplateOutlet="withLogo"></ng-container>
    </ng-container>
    <ng-container *notInPopulation="[populations.Default]">
      <ng-container *ngTemplateOutlet="withoutLogo"></ng-container>
    </ng-container>
  }
</div>

<!-- Without Logo -->
<ng-template #withoutLogo>
  <div class="container d-flex justify-content-center">
    <div class="banner-content">
      @if (titleLink) {
        <a class="d-flex text-white align-items-center banner-title-link" [routerLink]="[titleLink]">
          <h1>{{ title }}</h1>
          @if (showBtn) {
            <i class="material-icons">chevron_right</i>
          }
        </a>
      } @else {
        <div class="d-flex text-white align-items-center">
          <h1>{{ title }}</h1>
          @if (showBtn) {
            <i class="material-icons">chevron_right</i>
          }
        </div>
      }
      <div class="d-flex text-white">
        <div class="text-start member-id">
          <span> {{ subtitle }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- With Logo -->
<ng-template #withLogo>
  <div class="container d-flex">
    <div class="banner-content">
      @if (titleLink) {
        <a class="d-flex text-white align-items-center banner-title-link" [routerLink]="[titleLink]">
          <h1>{{ title }}</h1>
          @if (showBtn) {
            <i class="material-icons">chevron_right</i>
          }
        </a>
      } @else {
        <div class="d-flex text-white align-items-center">
          <h1>{{ title }}</h1>
          @if (showBtn) {
            <i class="material-icons">chevron_right</i>
          }
        </div>
      }
      <div class="d-flex text-white">
        <div class="text-start member-id">
          <span> {{ subtitle }}</span>
        </div>
      </div>
    </div>
    <div class="banner-logo ms-auto">
      <img [src]="'logos/rewards-logo.png' | contentAssetImage" alt="" class="src" />
    </div>
  </div>
</ng-template>
